// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2272":"3abdab92","2800":"a729ff26","4328":"19c4a935","5882":"3abdab92","6254":"19c4a935"}[chunkId] + ".chunk.css";
};